import { render, staticRenderFns } from "./ActivityLogManagement.vue?vue&type=template&id=53da0920&scoped=true"
import script from "./ActivityLogManagement.vue?vue&type=script&lang=ts"
export * from "./ActivityLogManagement.vue?vue&type=script&lang=ts"
import style0 from "./ActivityLogManagement.vue?vue&type=style&index=0&id=53da0920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53da0920",
  null
  
)

export default component.exports